import { render } from "./FoodView.vue?vue&type=template&id=55a19662&scoped=true"
import script from "./FoodView.vue?vue&type=script&lang=js"
export * from "./FoodView.vue?vue&type=script&lang=js"

import "./FoodView.vue?vue&type=style&index=0&id=55a19662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a19662"]])

export default __exports__